import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import CyberTrainingEmployeeTable from "./CyberTrainingEmployeeTable";

const CompanyEmployeesModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const handleEmployeeClick = (employee) => {
		props.onEmployeeClick(employee);
	};
	
	return (
		<Dialog
			open={props.companyEmployees? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Company Employees
			</DialogTitle>
			<DialogContent>
				<CyberTrainingEmployeeTable
					companyEmployees={props.companyEmployees}
					onEmployeeClick={handleEmployeeClick}
				/>
			</DialogContent>
		</Dialog>
	);

}

export default CompanyEmployeesModal;